import {
  SIDE_MENU_COLLAPSED,
  DETAIL_SHOWED,
  LOADING,
  SERVER_ERRORS,
  // EDITING,
} from "../types";

export const collapseSideMenu = (collapsed: any) => {
  return {
    type: SIDE_MENU_COLLAPSED,
    collapsed,
  };
};
export const setShowDetail = (showDetail: any) => {
  return {
    type: DETAIL_SHOWED,
    showDetail,
  };
};
// export const setEditing = (editing: boolean) => {
//   return {
//     type: EDITING,
//     editing,
//   };
// };

export const setLoading = (loading: boolean) => {
  return {
    type: LOADING,
    loading,
  };
};

export const setServerErrors = (errors: any) => {
  return {
    type: SERVER_ERRORS,
    errors,
  };
};



